import PrintPreferenceTabs from "../templete/PrintPreferenceTabs";
const PurchaseCreditNote = () => {
  return (
    <PrintPreferenceTabs type="purchase_credit_note"></PrintPreferenceTabs>
  );
};
export default PurchaseCreditNote;

